/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PregnantForm from './pregnantForm';
import ValidateUserForm from './validateUserForm';
import { getMaestras } from "../../actions/maestras-actions";
import { validatePreviousPregnanteByDocument } from '../../actions/licence-motherhood-actions';
import { useStateValue } from "../../context/store";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";

const RegisterPregnant = () => {
  const [{ }, dispatch] = useStateValue();
  const [showPregnantForm, setShowPregnantForm] = useState(false)
  const [showMessage,setShowMessage] = useState(false);
  const [userData,setUserData] = useState(null);

  const [maestras, setMaestras] = useState({
    estadoCivil: [],
    generos: [],
    nivelFormacion: [],
    respuestaAfirmacionNegacion: [],
    tallaCalzado: [],
    tallaLetras: [],
    tallaNumerosFemenino: [],
    tallaNumerosMasculino: [],
    tipoDocumnetoIdentificacion: [],
  });

  const getListaMaestras = async () => {
    const response = await getMaestras();
    setMaestras(response.data.maestras);
    return response.data.maestras;
  };

  useEffect(() => {
    getListaMaestras();
    dispatch({
      type: "SET_BREADCRUMB",
      breadCrumbText: "Registro de embarazo",
      breadCrumbSubText: "Registro de embarazo",
      index: 29,
    });
  }, []);

  const handleClickClose = () => {
    setShowMessage(false);
  };

  const [message, setMessage] = useState({
    description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
    textButtonSubmit: '',
    handleClick: () => handleClickClose(),
    handleClickOut: () => handleClickClose(),
    oneButtons: false,
    type: 'WARNING',
    open: false
  });

  const updateStatus = (userInfo) => {
    setShowPregnantForm(true); 
    setShowMessage(false);
    setTimeout(() => {
      setUserData(userInfo);
    }, 100);
  }

  //validateUserForm
  const onSubmit = async (data) => {
    if (!showPregnantForm) {
      const response = await validatePreviousPregnanteByDocument(data?.documentNumber, data?.documentType, dispatch);
      const description = response?.data?.detail
        ? response?.data?.detail
        : response?.data?.error
        ? response?.data?.error
        : `Ocurrió un error procesando la solicitud, inténtelo nuevamente`;
      if (response && (response?.status === 200 || response?.status === 201)) {
        const userInfo = response?.data
        if (userInfo?.contractTypeFormat?.status?.toUpperCase() === "ACTIVO") {
          updateStatus(userInfo);
        } else {
          setShowMessage(true);
          setShowPregnantForm(false);
        }
      } else if (
        response?.status > 399 &&
        response?.status !== 401 &&
        response?.sattus !== 403
      ) {
        setShowMessage(true);
        setMessage({
          description,
          textButtonSubmit: "Aceptar",
          handleClick: () => handleClickClose(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
      } else {
        setShowMessage(true);
        setMessage({
          description,
          textButtonSubmit: "ACEPTAR",
          handleClick: () => handleClickClose(),
          oneButtons: true,
          type: "WARNING",
          open: true,
        });
      }
      
    }
  };

  return (
    <div>
      {showMessage &&<ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={showMessage}
      />}
      <ValidateUserForm
        maestras={maestras}
        onSubmit={onSubmit}
        showRefundForm={showPregnantForm}
      />
      {showPregnantForm && userData ? 
        <PregnantForm 
          user={userData} 
          maestras={maestras} 
          setMessage={setMessage}
          message={message}
          setShowMessage={setShowMessage}
          dispatch={dispatch}
        /> 
        :  null}

    </div>
  )
}

export default RegisterPregnant;